// extracted by mini-css-extract-plugin
export default {"appFrame":"appFrame__appFrame--SKJ2Y","mainContentBelowHeader":"appFrame__mainContentBelowHeader--dCUxU","main":"appFrame__main--OvnlF"};